export enum StandardIntercomSearchTerm {
    CulturalLeadership = "cultural leadership",
    PersonalProfile = "personal profile",
    ManagePeople = "manage people",
    ManageRoles = "manage roles",
}
